<div class="min-h-screen bg-section flex flex-col items-center justify-center p-6 relative overflow-hidden text-body-text selection:bg-btn/30">
  <!-- Botanical Decoration (Top Left) -->
  <div class="absolute -top-6 -left-6 sm:-top-12 sm:-left-12 w-32 h-32 sm:w-64 sm:h-64 md:w-96 md:h-96 opacity-40 sm:opacity-60 pointer-events-none">
    <img src="amla-top-left.jpg" alt="Amla Branch" class="w-full h-full object-contain mix-blend-multiply aspect-square transform -rotate-12" />
  </div>

  <!-- Botanical Decoration (Bottom Right) -->
  <div class="absolute -bottom-6 -right-6 sm:-bottom-12 sm:-right-12 w-40 h-40 sm:w-80 sm:h-80 md:w-[30rem] md:h-[30rem] opacity-40 sm:opacity-60 pointer-events-none">
    <img src="amla-bottom-right.png" alt="Ashwagandha Root" class="w-full h-full object-contain mix-blend-multiply aspect-square transform rotate-12" />
  </div>

  <!-- Main Content -->
  <div class="relative z-10 w-full max-w-2xl mx-auto flex flex-col items-center text-center space-y-6 md:space-y-8 animate-fade-in px-4">
    <!-- Logo/Brand -->
    <div class="space-y-4">
      <img src="FINAL.png" alt="Aarvya Logo" class="w-48 sm:w-64 h-auto mx-auto object-contain">
    </div>

    <!-- Auth Card -->
    <div class="w-full max-w-md mx-auto bg-white/80 backdrop-blur-sm border border-[#E5DDD5] shadow-lg p-6 sm:p-8 space-y-5 text-left">
      <div class="space-y-1">
        <h2 class="text-2xl sm:text-3xl font-serif text-heading">Forgot Password?</h2>
        <p class="text-sm text-muted">Enter your email and we'll send you a link to reset your password.</p>
      </div>

      <form [formGroup]="forgotPasswordForm" (ngSubmit)="submit()" class="space-y-4">
        <div class="space-y-1">
          <label class="block text-xs font-serif text-heading tracking-wide">Email</label>
          <input
            type="email"
            formControlName="email"
            placeholder="Enter your email"
            class="w-full px-4 py-3 bg-white border text-body-text placeholder-muted/60 font-serif focus:outline-none transition-colors rounded-sm"
            [class.border-[#E5DDD5]]="!email?.touched || email?.valid"
            [class.border-red-300]="email?.invalid && email?.touched"
            [disabled]="isSubmitting || isSuccess"
          />
          <div *ngIf="email?.invalid && email?.touched" class="mt-1 text-xs text-red-500 font-sans">
            <span *ngIf="email?.hasError('required')">Email is required</span>
            <span *ngIf="email?.hasError('email')">Please enter a valid email</span>
          </div>
        </div>

        <button
          type="submit"
          class="w-full px-6 py-3 bg-btn text-white font-serif tracking-wide rounded-sm shadow-md hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 uppercase text-sm sm:text-base flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed"
          [disabled]="forgotPasswordForm.invalid || isSubmitting || isSuccess"
        >
          <span *ngIf="!isSubmitting">Send Reset Link</span>
          <span *ngIf="isSubmitting" class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
        </button>

        <div *ngIf="isSuccess" class="p-3 bg-green-50 border border-green-200 rounded-sm text-sm text-green-700 mt-1 text-center">
          Reset link sent! Please check your email.
        </div>
        
        <div *ngIf="errorMessage" class="p-3 bg-red-50 border border-red-200 rounded-sm text-sm text-red-700 mt-1 text-center">
          {{ errorMessage }}
        </div>
      </form>

      <div class="pt-2 text-xs sm:text-sm text-muted flex items-center justify-center gap-1">
        <span>Remembered your password?</span>
        <a routerLink="/sign-in" class="text-heading underline underline-offset-2 hover:text-body-text">Sign in</a>
      </div>
    </div>
  </div>
</div>
